import http from "../../../core/utils/apis/api";

const getTrainingEvaluationsQuestionsData = async (page, take) => {
  try {
    const response = await http({
      method: "GET",
      url: "/trainingEvaluationsQuestions",
      params: {
        page: page,
        take: take,
      },
    });
    return response;
  } catch (e) {
    throw e;
  }
};

const submitReviewScores = async (scores) => {
  try {
    const response = await http({
      method: "POST",
      url: "/trainingEvaluationScore",
      data: { scores },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const findByEvalLink = async (trainingId, userId) => {
  try {
    const response = await http({
      method: "GET",
      url: `/training-evaluations/${trainingId}/${userId}`,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const getTrainingInformationHeader = async (id) => {
  try {
    const response = await http({
      method: 'GET',
      url: `trainings/${id}`
    });

    return response;
  } catch (e) {
    throw e;
  }
};

const getEvaluationScoresByTrainingIdAndUserId = async (trainingId, userId) => {
  try {
    const response = await http({
      method: 'GET',
      url: `trainingEvaluationScore/${trainingId}/${userId}`
    });

    return response;
  } catch (e) {
    throw e;
  }
};

const reviewTrainingService = {
  getTrainingEvaluationsQuestionsData,
  submitReviewScores,
  findByEvalLink,
  getTrainingInformationHeader,
  getEvaluationScoresByTrainingIdAndUserId,
};

export default reviewTrainingService;
